import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import { useTypedSelector } from 'client/reducer'
import { setBaseClass } from 'client/utils'
import * as React from 'react'

import useAccountingNavigation from '../hooks/useAccountingNavigation'
import './AgerasNavbar.scss'

const cls = setBaseClass('AgerasNavbar')

interface AgerasNavbarProps {
  agerasNextMigration: boolean
}

const AgerasNavbar: React.FunctionComponent<AgerasNavbarProps> = ({ agerasNextMigration }) => {
  const { handleAccountingNavigation } = useAccountingNavigation(agerasNextMigration)

  return (
    <div className={cls()}>
      <div className={cls('__buttons')}>
        <div className={cls('__buttons__tooltipWrapper')}>
          <div className={cls('__buttons__ZervantActive')}>
            <div className={cls('__buttons__ZervantActive__body')}>
              <div className={cls('__buttons__ZervantActive__body__icon')} />
            </div>
          </div>
          <div className={cls('__buttons__ZervantActive__tooltip')}>
            <div className={cls('__buttons__ZervantActive__tooltip__arrow')} />
            <div className={cls('__buttons__ZervantActive__tooltip__hoverInfo')}>
              <div className={cls('__buttons__ZervantActive__tooltip__hoverInfo__text')}>
                {l('AgerasNavbar.hoverInfo.Invoicing')}
              </div>
            </div>
          </div>
        </div>
        <div className={cls('__buttons__tooltipWrapper')}>
          <div
            className={cls('__buttons__navToAccounting')}
            onClick={() => {
              Segment.track(SegmentEvents.experiments.goToAccountingClickedNavbar, { button_clicked: 'go to ACC' })
              handleAccountingNavigation()
            }}
          >
            <div className={cls('__buttons__navToAccounting__icon')} />
          </div>
          <div className={cls('__buttons__navToAccounting__tooltip')}>
            <div className={cls('__buttons__navToAccounting__tooltip__arrow')} />
            <div className={cls('__buttons__navToAccounting__tooltip__hoverInfo')}>
              <div className={cls('__buttons__navToAccounting__tooltip__hoverInfo__text')}>
                {l('AgerasNavbar.hoverInfo.Accounting')}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cls('__logo')} />
    </div>
  )
}

export default AgerasNavbar
